import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import {
	CONNECTION_TEXT_KEY,
	SignalIcon,
	useConnectionStats,
} from "../../../../../../ConnectionQuality";

const Root = styled.div`
	display: flex;
	align-items: center;

	height: 48px;
	padding-inline: 12px;

	cursor: default;
`;

const Tracker = memo(() => {
	const { t } = useTranslation();
	const { level } = useConnectionStats();

	return (
		<Root
			role="img"
			aria-label={`${t(`${CONNECTION_TEXT_KEY}.title`)}: ${t(
				`${CONNECTION_TEXT_KEY}.level.${level}`,
			)}`}
		>
			<SignalIcon level={level} />
		</Root>
	);
});

export default Tracker;
